// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"204609a8","375":"92f667b5","411":"bc0f3900","436":"df3ef919"}[chunkId] + ".chunk.js";
};